/**
 * Placeholder of a masked filter value label (anonymized users), replaced by the front with the
 * 1-based position of the value in the displayed list, so two masked values never share the same label.
 * @example 'EAN {index} - *******' → 'EAN 3 - *******'
 */
export const ANONYMIZED_LABEL_INDEX_PLACEHOLDER = '{index}';
/**
 * Mask shown in place of a real code (EAN, item, brand, ...) to an anonymized user. Suffix of the masked
 * labels built by the api, and label of a selected value whose label is not resolved yet on the front.
 */
export const ANONYMIZED_LABEL_MASK = '*******';
//# sourceMappingURL=anonymizedLabel.constant.js.map